module.exports = __webpack_public_path__ + "86643e5bebed8e1ff163238e58e16d51.woff2";